import React from 'react'

export default <>
  <path d="M30.0695 9.01709L25.0645 49.0171M56.0955 9.01709L61.0645 48.9671M43.0825 9.01709V15.6838M43.0825 41.2393V49.0171M43.0825 24.5726V32.3504" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
</>